import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelRadio as _vModelRadio, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d01a1e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "delete-note-model-label"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "modal-body" }
const _hoisted_12 = { class: "wrapper" }
const _hoisted_13 = { class: "btn_container" }
const _hoisted_14 = ["checked"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "btn_container" }
const _hoisted_17 = ["checked"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "btn_container" }
const _hoisted_20 = ["checked"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = { class: "modal-footer" }
const _hoisted_23 = ["disabled"]

import $ from 'jquery';
import _get from 'lodash/get';
import { ref, computed, PropType, inject } from 'vue';
import { useStore } from 'vuex';
// Import your models or other external methods
import { Booking } from "@/models";

export default /*#__PURE__*/_defineComponent({
  __name: 'RecursionConfirmModal',
  props: {
  booking: { type: Object as PropType<Booking> },
  id: String
},
  emits: ['select','selectedit'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;
const store = useStore();
const operation = ref("");
// Props
const props = __props;
const saveBooking = (booking: Booking): Promise<any> => {
  return store.dispatch('diary/saveBooking', booking);
};

const realtime: any = inject('realtime');
const actProperty: any = inject('actProperty');

const channel = realtime.channels.get('diary');
const deviceid = actProperty.getDeviceId();

const booking = ref(props.booking);
const copybooking = ref(props.booking);

const radiovalue = ref('');
const titlenoteschanged = ref(false);

// Methods
const init = (bookingData: Booking) => {
  radiovalue.value = '';
  booking.value = bookingData;
};

const show = () => {
  if ($(`#${props.id}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.id + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#${props.id}`).show();
  }
}
const hide = () => {
  if ($(`#${props.id}`).length > 0) {
    $(`#${props.id}` + 'Backdrop').remove();
    if (titlenoteschanged.value) {
      saveBooking(booking.value).then((b: Booking) => {
        channel.publish('appointmentChanged', { deviceid: deviceid, bookingid: b.id, source: 'Scheduler' });
        $(`#${props.id}`).hide();
      });
    }
    $(`#${props.id}`).hide();
  }
};
// const show = () => {
//   if ($('#delete-note-model-Backdrop').length == 0) {
//     const backdropDiv = $('<div class="modal-backdrop fade show" id="delete-note-model-Backdrop"></div>');
//     $('body').append(backdropDiv);
//     let el = $(`#delete-note-model`);
//     el.show();
//   }
// }


// const hide = () => {
//   if ($('#delete-note-model-Backdrop').length > 0) {
//     $('#delete-note-model-Backdrop').remove();
//   }
//   if (titlenoteschanged.value) {
//     saveBooking(booking.value).then((b: Booking) => {
//       channel.publish('appointmentChanged', { deviceid: deviceid, bookingid: b.id, source: 'Scheduler' });
//       $(`#delete-note-model`).hide();
//     });
//   }
//   else {
//     $(`#delete-note-model`).hide();
//   }
// };


const saveAll = () => {
  if(operation.value === 'edit-scheduler') {
    emit('selectedit', radiovalue.value, booking.value,copybooking.value);
  } else {
    emit('select', radiovalue.value, booking.value);
  }
}

const emitLabel = (val: string) => {
  radiovalue.value = val;
};

const emitSelect = (val: string) => {
  radiovalue.value = val;
};
const edit = () => {
  operation.value = "edit";
};

const editScheduler = () => {
  operation.value = "edit-scheduler";
};
const deletes = () => {
  operation.value = "deletes";
}

__expose({ init, show, hide, deletes, edit,editScheduler});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`delete-note-model-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, [
            (operation.value === 'edit-scheduler')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Edit recurring event"))
              : _createCommentVNode("", true),
            (operation.value === 'edit')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Edit recurring event"))
              : _createCommentVNode("", true),
            (operation.value === 'deletes')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Delete recurring event"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _withModifiers(hide, ["prevent"])
          }, _hoisted_10)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(), _createElementBlock("div", {
            id: "delete-note-model-body",
            key: radiovalue.value
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "thisevent",
                  name: "radio",
                  id: "thisevent",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((radiovalue).value = $event)),
                  checked: radiovalue.value === 'thisevent',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emitSelect('thisevent')))
                }, null, 8, _hoisted_14), [
                  [_vModelRadio, radiovalue.value]
                ]),
                _createElementVNode("label", {
                  for: "seen",
                  class: "seen",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (emitLabel('thisevent')))
                }, "This Event")
              ]),
              _hoisted_15,
              _createElementVNode("label", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "thisandfollowingevent",
                  name: "radio",
                  id: "thisandfollowingevent",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((radiovalue).value = $event)),
                  checked: radiovalue.value === 'thisandfollowingevent',
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (emitSelect('thisandfollowingevent')))
                }, null, 8, _hoisted_17), [
                  [_vModelRadio, radiovalue.value]
                ]),
                _createElementVNode("label", {
                  for: "seen",
                  class: "seen",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (emitLabel('thisandfollowingevent')))
                }, "This and following events")
              ]),
              _hoisted_18,
              _createElementVNode("label", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "allevents",
                  class: "allevents",
                  name: "radio",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((radiovalue).value = $event)),
                  checked: radiovalue.value === 'allevents',
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (emitSelect('allevents')))
                }, null, 8, _hoisted_20), [
                  [_vModelRadio, radiovalue.value]
                ]),
                _createElementVNode("label", {
                  for: "seen",
                  class: "seen",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (emitLabel('allevents')))
                }, "All events")
              ]),
              _hoisted_21
            ])
          ]))
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            "data-dismiss": "modal",
            onClick: _withModifiers(hide, ["prevent"])
          }, " Cancel "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            "data-dismiss": "modal",
            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (saveAll()), ["prevent"])),
            disabled: !radiovalue.value
          }, " OK ", 8, _hoisted_23)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})